import { render } from "./404.vue?vue&type=template&id=9a96a208&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=9a96a208&scoped=true&lang=css"

import exportComponent from "D:\\EZENMS_VUE\\eze-nms-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a96a208"]])

export default __exports__